import { IconCollection } from "components/Icon/IconCollection";
import TableOptionMenu from "./TableOptionMenu";
import { TableDensity } from "./tableUtils";

const DENSITY_OPTIONS: { value: TableDensity; label: string }[] = [
    { value: "regular", label: "Comfortable" },
    { value: "medium", label: "Cozy" },
    { value: "high", label: "Compact" },
];

type TableDensitySelectorProps = {
    density: TableDensity;
    setDensity: (density: TableDensity) => void;
};

/**
 * Toolbar control to pick the row density of a table. Uses the shared
 * {@link TableOptionMenu}; the chosen value is persisted per table by the
 * parent RecordTable via its settings key.
 */
const TableDensitySelector = ({ density, setDensity }: TableDensitySelectorProps) => (
    <TableOptionMenu
        icon={IconCollection.formatLineSpacing}
        label="Row density"
        value={density}
        options={DENSITY_OPTIONS}
        onChange={setDensity}
        className="tableDensitySelector"
    />
);

export default TableDensitySelector;
